export const Head = {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async loadScript(context, payload) {
            let script = document.createElement('script');
            if ('name' in payload) {
                script.setAttribute('data-name', payload.name);
            }
            if ('src' in payload) {
                script.setAttribute('src', payload.src);
            }
            if ('inner' in payload) {
                script.text = payload.inner;
            }
            if ('async' in payload) {
                script.setAttribute('async', payload.async);
            }
            if ('defer' in payload) {
                script.setAttribute('defer', payload.defer);
            }
            document.head.appendChild(script);
        },
        async initHeadScripts(context) {
            /* google analytics (will be removed on live sites by publish process) */
            context.dispatch('loadScript', {
                src: 'https://www.googletagmanager.com/gtag/js?id=UA-123253554-1',
                async: true,
                name: 'analytics-1'
            });
            context.dispatch('loadScript', {
                inner: `
                        if (document.cookie.indexOf('ga-disable=true') > -1) { window['ga-disable-UA-123253554-1'] = true; }
                        window.dataLayer = window.dataLayer || [];
                        function gtag() { dataLayer.push(arguments); }
                        gtag('js', new Date());
                        gtag('config', 'UA-123253554-1', { 'anonymize_ip': true });
                    `.replace(/\s+/g, ' '),
                name: 'analytics-2'
            });
        },
        async preloadFonts() {
            if (window.location.pathname.indexOf('render') === -1) {
                window.setTimeout(() => {
                    /* technique 1 (not used, because fonts change and we do not know if we need woff or woff2) */
                    /*
                    let link = document.createElement('link');
                    link.setAttribute('rel', 'preload');
                    link.setAttribute('as', 'font');
                    link.setAttribute('href', 'static/fonts/barlow-v2-latin-100.woff2');
                    link.setAttribute('href', 'static/fonts/barlow-v2-latin-200.woff2');
                    // ...
                    document.head.appendChild(link);
                   */
                    /* technique 2 (simple and pragmatic) */
                    let html = '';
                    html += '<div class="fonts-preloader" style="opacity:0;position:absolute;">';
                    for (let i = 1; i <= 20; i++) {
                        html += '<span class="fonts-preloader__title--' + i + '"></span>';
                        html += '<span class="fonts-preloader__paragraph--' + i + '"></span>';
                    }
                    html += '</div>';
                    document.body.insertAdjacentHTML('beforeend', html);
                }, 1000);
            }
        },
        async updateHeadTitle(context, payload) {
            if (document.querySelector('head title') === null) {
                return;
            }
            document.querySelector('head title').innerText = payload;
        },
        async updateHeadDescription(context, payload) {
            if (document.querySelector('head meta[name="description"]') === null) {
                let child = document.createElement('meta');
                child.setAttribute('name', 'description');
                child.setAttribute('content', '');
                document.head.appendChild(child);
            }
            document.querySelector('head meta[name="description"]').content = payload;
        },
        async updateHeadFavicon(context) {
            let file_favicon = context.getters.getProp('deha.user.misc.favicon'),
                file_logo = context.getters.getProp('deha.user.misc.logo'),
                href = null,
                type = null;
            if (file_favicon !== undefined && file_favicon !== null && file_favicon !== '') {
                href = context.rootGetters.generateMediaUrl({ id: file_favicon.id, w: 16, h: 16 });
                type = context.rootGetters.getFiletypeById(file_favicon.id);
            } else if (file_logo !== undefined && file_logo !== null && file_logo !== '') {
                href = context.rootGetters.generateMediaUrl({ id: file_logo.id, w: 16, h: 16 });
                type = context.rootGetters.getFiletypeById(file_logo.id);
            } else if (href === null || href === undefined || type === null || type === undefined) {
                href = '/files/static/ui/misc/favicon.png';
                type = 'image/png';
            }
            if (document.querySelector('head link[rel="icon"]') === null) {
                let child = document.createElement('link');
                child.setAttribute('rel', 'icon');
                child.setAttribute('href', '');
                child.setAttribute('sizes', '16x16');
                child.setAttribute('type', 'image/png');
                document.head.appendChild(child);
            }
            document.querySelector('head link[rel="icon"]').setAttribute('href', href);
            document.querySelector('head link[rel="icon"]').setAttribute('type', type);
        },
        async updateHtmlClasses(context) {
            for (let settings_group of ['fontfamily', 'colorscheme', 'iconstyle', 'theme']) {
                await context.dispatch('updateHtmlClass', settings_group);
            }
        },
        async updateHtmlClass(context, settings_group) {
            let html_classes = document.documentElement.classList;
            if (html_classes.length > 0) {
                [...html_classes].forEach((html_classes__value) => {
                    if (
                        html_classes__value !== undefined &&
                        html_classes__value !== null &&
                        html_classes__value.indexOf(settings_group + '--') === 0
                    ) {
                        html_classes.remove(html_classes__value);
                    }
                });
            }
            let val = context.getters.getProp('tecpage.user.settings.' + settings_group);
            if (val !== undefined && val !== null && val !== '') {
                document.documentElement.classList.add(settings_group + '--' + val);
                if (settings_group === 'colorscheme') {
                    context.dispatch('updateColorschemeVars');
                }
            }
        }
    }
};
